import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';

export const TAB_SX = { textTransform: 'none', fontWeight: 600, fontSize: '0.8125rem', minHeight: 40 };

/**
 * Page made of tabs; the selected tab lives in the URL (?tab=key) so links and refresh keep it.
 * tabs: [{ key, label, element, hidden? }]
 */
const TabbedPage = ({ tabs, param = 'tab', sx }) => {
  const [params, setParams] = useSearchParams();
  const visible = tabs.filter((t) => !t.hidden);
  const current = visible.find((t) => t.key === params.get(param)) || visible[0];

  const select = (key) => {
    const next = new URLSearchParams(params);
    next.set(param, key);
    setParams(next, { replace: true });
  };

  if (!current) return null;
  return (
    <Box sx={{ width: 0, minWidth: '100%', ...sx }}>
      {visible.length > 1 && (
        <Tabs value={current.key} onChange={(e, v) => select(v)} variant="scrollable" scrollButtons="auto"
          sx={{ mb: 2, minHeight: 40, borderBottom: 1, borderColor: 'divider' }}>
          {visible.map((t) => <Tab key={t.key} value={t.key} label={t.label} sx={TAB_SX} />)}
        </Tabs>
      )}
      <Box key={current.key}>{current.element}</Box>
    </Box>
  );
};

export default TabbedPage;
